import { render } from "./card-block.vue?vue&type=template&id=39ccf32c&scoped=true&ts=true"
import script from "./card-block.vue?vue&type=script&lang=ts"
export * from "./card-block.vue?vue&type=script&lang=ts"

import "./card-block.vue?vue&type=style&index=0&id=39ccf32c&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ccf32c"]])

export default __exports__